import { useTranslation } from 'react-i18next';
import env from '@/env';

export const useTacticsNavigationItem = () => {
  const { t } = useTranslation('navigation');

  return {
    id: 'tactics',
    icon: 'IqTactics' as const,
    path: `https://${env.VITE_IQ_DOMAIN}/engine-room`,
    label: t('crossPlatform.primary.tactics'),
  };
};
